import { render, staticRenderFns } from "./technical_records.vue?vue&type=template&id=9f5d027e"
import script from "./technical_records.vue?vue&type=script&lang=js"
export * from "./technical_records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports